export default __webpack_public_path__ + "static/media/Thumbnail-Newsletter-9.12ef5add.png";